import type { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import TrialInstitutionIdentityContext from "src/contexts/data/TrialInstitutionIdentityContext";
import type { GetTrialInstitutionIdentityByIdResponse } from "src/api/Tmd.dtos";
import useTrialInstitutionIdentityById from "src/hooks/data/load/useTrialInstitutionIdentityById";
import type { SWRConfiguration } from "swr";

interface ITrialInstitutionProviderProps extends PropsWithChildren {
    id?: number;
    configuration?: SWRConfiguration<
        GetTrialInstitutionIdentityByIdResponse,
        GetTrialInstitutionIdentityByIdResponse
    >;
}

const TrialInstitutionIdentityProvider: FC<ITrialInstitutionProviderProps> = ({
    children,
    id,
    configuration,
}) => {
    const context = useTrialInstitutionIdentityById(id, configuration);

    return (
        <TrialInstitutionIdentityContext.Provider value={context}>
            {children}
        </TrialInstitutionIdentityContext.Provider>
    );
};

export const RouteTrialInstitutionIdentityProvider: FC<PropsWithChildren> = ({ children }) => {
    const { trialInstitutionId } = useParams<{ trialInstitutionId: string }>();
    const id = trialInstitutionId ? parseInt(trialInstitutionId, 10) : undefined;

    return <TrialInstitutionIdentityProvider id={id}>{children}</TrialInstitutionIdentityProvider>;
};

export default TrialInstitutionIdentityProvider;
